import {
  BigBlueCampaignTriggerEnum,
  BIGBLUE_BACKORDER_DEFAULT_CONFIG,
  CampaignTriggerIntegrationSchema,
  CampaignTriggerTypeEnum,
  EmailCampaignChannelIntegrationSchema,
  getEmailCampaignChannelIntegration,
  ShopifyCampaignTriggerEnum,
  type CampaignTriggerType,
} from "schema"
import { z } from "zod"

type TriggerIntegration = z.infer<typeof CampaignTriggerIntegrationSchema>
type EmailIntegration = z.infer<typeof EmailCampaignChannelIntegrationSchema>

export function replaceCampaignTriggerEmail(
  triggerIntegration: TriggerIntegration | null | undefined,
  email: EmailIntegration,
) {
  if (triggerIntegration?.type === "shopify" || triggerIntegration?.type === "bigblue") {
    return { ...triggerIntegration, email }
  }

  return email
}

export function clearCampaignTriggerEmail(
  triggerIntegration: TriggerIntegration | null | undefined,
) {
  if (triggerIntegration?.type === "shopify" || triggerIntegration?.type === "bigblue") {
    return { ...triggerIntegration, email: undefined }
  }

  return null
}

export function getCampaignTriggerEmail(triggerIntegration: TriggerIntegration | null | undefined) {
  return getEmailCampaignChannelIntegration(triggerIntegration)
}

export function getTriggerIntegrationWithEmail(
  triggerIntegration: TriggerIntegration | null | undefined,
  trigger: CampaignTriggerType,
) {
  const email = getCampaignTriggerEmail(triggerIntegration)
  if (!email) return null

  switch (trigger) {
    case CampaignTriggerTypeEnum.Webhook:
    case CampaignTriggerTypeEnum.Manual:
      return email
    case CampaignTriggerTypeEnum.Shopify:
      return {
        type: "shopify" as const,
        trigger: ShopifyCampaignTriggerEnum.AbandonCheckout,
        email,
      }
    case CampaignTriggerTypeEnum.BigBlue:
      return {
        type: "bigblue" as const,
        trigger: BigBlueCampaignTriggerEnum.Backorder,
        backorder:
          triggerIntegration?.type === "bigblue"
            ? (triggerIntegration.backorder ?? BIGBLUE_BACKORDER_DEFAULT_CONFIG)
            : BIGBLUE_BACKORDER_DEFAULT_CONFIG,
        email,
      }
    default:
      return null
  }
}
